import React from "react";
import { Col, InputNumber, Row } from "antd";
import style from "../../index.module.scss";
import { RuleObject, StoreValue } from "rc-field-form/es/interface";
import FieldWithError from "components/FieldWithError";
import fieldStyle from "./index.module.scss";

export default function FieldScore() {
    // 校验分值
    function scoreValidator(rule: RuleObject, value: StoreValue) {
        if (value > 0) return Promise.resolve();
        else return Promise.reject(rule.message);
    }

    return (
        <Row gutter={[0, 20]} className={fieldStyle.root}>
            <Col span={4} className={style.label}>
                <i className={style.required}>*</i> 本题分值
            </Col>

            <Col span={3} offset={1}>
                <FieldWithError
                    name="score"
                    initialValue={1}
                    rules={[
                        { validator: scoreValidator, message: "请填写分值!" }
                    ]}>
                    <InputNumber precision={1} min={0.5} max={1000} />
                </FieldWithError>
            </Col>

            <Col span={10} className={fieldStyle.tip}>
                (本题分值只能输入半角数值且输入分值不能大于999.9)
            </Col>
        </Row>
    );
}
